module.exports = __webpack_public_path__ + "static/media/gamesPlayed_250_500.aa131d24.png";